import { Chapter, ExamPrepare, Exam } from './'; // This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html


export default {
  path: 'ques-store',
  name: 'Ques store',
  childRoutes: [
    { path: '/ques/chapter/:name', name: 'Chapter', component: Chapter },
    { path: '/ques/prepare/:id', name: 'Exam prepare', component: ExamPrepare },
    { path: '/ques/exam/:name/:id', name: 'Exam', component: Exam },
  ],
};



// WEBPACK FOOTER //
// ./src/features/ques-store/route.js